import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { seo } from "@utils/seo";
import i18n from "@modules/shared/localization/i18n";
import { useAuthActions } from "@modules/auth/provider/AuthActionsProvider";

export const Route = createFileRoute(
  "/$locale/_layout/(protected)/_protected/account/",
)({
  component: AccountPage,
  head: ({ params }) => {
    const t = i18n.getFixedT(params.locale);
    return {
      meta: [
        ...seo({
          title: t("Seo:account.title"),
          description: t("Seo:account.description"),
        }),
      ],
    };
  },
});

function AccountPage() {
  const { t } = useTranslation();
  const { locale } = Route.useParams();
  const { logout, loading } = useAuthActions();

  return (
    <div className="min-h-screen px-4 py-10 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <h1 className="text-2xlarge text-text-1 mb-8 font-bold">
          {t("Account.title")}
        </h1>

        <div className="grid gap-6 md:grid-cols-2">
          {/* Orders */}
          <Link
            to="/$locale/account/orders"
            params={{ locale }}
            className="border-border-5 hover:border-primary rounded-lg border p-6 transition-colors"
          >
            <h2 className="text-text-1 text-large mb-2 font-semibold">
              {t("Account.orders.title")}
            </h2>
            <p className="text-text-3">{t("Account.orders.description")}</p>
          </Link>

          {/* Addresses */}
          <Link
            to="/$locale/account/addresses"
            params={{ locale }}
            className="border-border-5 hover:border-primary rounded-lg border p-6 transition-colors"
          >
            <h2 className="text-text-1 text-large mb-2 font-semibold">
              {t("Account.addresses.title")}
            </h2>
            <p className="text-text-3">{t("Account.addresses.description")}</p>
          </Link>

          {/* Profile */}
          <Link
            to="/$locale/account/profile"
            params={{ locale }}
            className="border-border-5 hover:border-primary rounded-lg border p-6 transition-colors"
          >
            <h2 className="text-text-1 text-large mb-2 font-semibold">
              {t("Account.profile.title")}
            </h2>
            <p className="text-text-3">{t("Account.profile.description")}</p>
          </Link>

          {/* Logout */}
          <button
            type="button"
            onClick={() => {
              void logout();
            }}
            disabled={loading}
            className="border-border-5 hover:border-error rounded-lg border p-6 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-60"
          >
            <h2 className="text-text-1 text-large mb-2 font-semibold">
              {t("Account.logout.title")}
            </h2>
            <p className="text-text-3">{t("Account.logout.description")}</p>
          </button>
        </div>
      </div>
    </div>
  );
}
